const state = {
  globalLoading: false,
  globalLoadingMessageArray: [],
  snackbar: false,
  snackbarType: '',
  snackbarText: '',
  confirmationDialog: false,
  confirmationDialogConfig: {},
  exibirMensagem: false,
  tituloMensagem: '',
  textoMensagem: ''
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/ui/state.js